import { createReducer } from '@reduxjs/toolkit'
import { ICourse } from 'shared/types'
import { receiveLibrary } from 'src/model/actions'

const initialState = null as Record<string, ICourse> | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveLibrary, (state, action) => action.payload)
})

export default reducer
